const translations = {
  error: 'Error',
  partialSuccess: 'Partial success',
  errorHasOccurred:
    'An error has occurred with this request, please try again in a few minutes.',
  ok: 'OK',
};

export default translations;
